// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BYO61","image":"styles_image__1ecFZ","submitButton":"styles_submitButton__1hldh","clickHere":"styles_clickHere__22mAe"};